import React from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { Text } from '@chakra-ui/react';

interface VersionSyncDialogProps {
  isOpen: boolean;
  onClose: () => void;
  handleAction: () => void;
}

export const VersionSyncDialog: React.FC<VersionSyncDialogProps> = ({
  isOpen,
  handleAction,
  onClose,
}) => (
  <ChakraConfirmationDialog
    title="Sync"
    actionButtonText="Sync"
    cancelButtonText="Cancel"
    isOpen={isOpen}
    handleAction={handleAction}
    handleClose={onClose}
    onClose={onClose}
  >
    <Text fontSize="md">
      Syncing from the Song will fetch all relevant updates from the song.
    </Text>
  </ChakraConfirmationDialog>
);
